import * as React from "react";
import { Tag } from "antd";
import { API } from "General/API";
import { projectsDataStore } from "Stores";
import { observer } from "mobx-react";
import { Loader } from "Components/General/Loader";
import { ErrorDisplay } from "Components/General/Error";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { API_URL } from "General/APIEndpoints";

interface FileAnalyzeProps extends WithTranslation {
  fileId: number;
}

interface FileAnalyzeState {
  data: { [entity: string]: string[] };
  loading: boolean;
  error: JSX.Element;
}

export const FileAnalyze = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<FileAnalyzeProps, FileAnalyzeState> {
      entityNames = {
        persons: "persons",
        locations: "locations",
        organisations: "organisations",
        mails: "emails",
        homepages: "homepages",
        dates: "dates",
      };

      constructor(props: FileAnalyzeProps) {
        super(props);

        this.state = {
          data: {},
          loading: false,
          error: null,
        };
      }

      componentDidMount() {
        this.fetchAnalyze(this.props.fileId);
      }

      fetchAnalyze = async (fileId: number) => {
        try {
          this.setState({ loading: true });
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const response = await API.getData(API_URL.FILES.getContentinfo(projectsDataStore.projectId, fileId));
          this.setState({ data: response, error: null });
        } catch (err) {
          this.setState({ error: <ErrorDisplay err={err} /> });
          throw err;
        } finally {
          this.setState({ loading: false });
        }
      };

      render() {
        const { data, loading, error } = this.state;
        const { t } = this.props;
        return loading ? (
          <Loader />
        ) : (
          <div>
            {Object.keys(data)
              .filter((key) => data[key].length)
              .map((key) => (
                <div key={key} style={{ marginBottom: "1em" }}>
                  <p>
                    <b>{t(this.entityNames[key])}:</b>
                  </p>
                  {Array.isArray(data[key]) &&
                    data[key].map((item) => (
                      <Tag style={{ marginBottom: 5, cursor: "default" }} key={item}>
                        {item}
                      </Tag>
                    ))}
                </div>
              ))}
            {error}
          </div>
        );
      }
    }
  )
);
